import { bootstrapApplication } from '@angular/platform-browser';
import { MediveliusAppConfig } from './app/mediveliusAppConfig';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, MediveliusAppConfig).catch((err) => console.error(err));
